export default __webpack_public_path__ + "static/media/jen-macklin.5bc2ee4d.jpeg";